import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Types
import { ItemType } from 'Shared/types/MeetingItem.type';

// Hooks
import { useToggle } from '../hooks';

// Actions
import { fetchHomePageData } from 'Shared/actions/HomePage.actions';

type Props = {
  itemType?: ItemType;
};

export const useFetchHomePageData = ({ itemType }: Partial<Props> = {}) => {
  const dispatch = useDispatch();

  const [isLoading, toggleIsLoading] = useToggle(true);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    const params = {
      type: itemType,
    };
    dispatch(fetchHomePageData(params)).then(response => {
      setResponse(response);
      toggleIsLoading();
    });
  }, []);

  return { isLoading, response };
};
